/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  StabilityPoolManager,
  StabilityPoolManagerInterface,
} from "../StabilityPoolManager";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "stabilityPool",
        type: "address",
      },
    ],
    name: "addStabilityPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "adminContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
    ],
    name: "getAssetStabilityPool",
    outputs: [
      {
        internalType: "contract IStabilityPool",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "stabilityPool",
        type: "address",
      },
    ],
    name: "isStabilityPool",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
    ],
    name: "removeStabilityPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_adminContract",
        type: "address",
      },
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    name: "setAdminContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "unsafeGetAssetStabilityPool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type StabilityPoolManagerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: StabilityPoolManagerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class StabilityPoolManager__factory extends ContractFactory {
  constructor(...args: StabilityPoolManagerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<StabilityPoolManager> {
    return super.deploy(overrides || {}) as Promise<StabilityPoolManager>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): StabilityPoolManager {
    return super.attach(address) as StabilityPoolManager;
  }
  override connect(signer: Signer): StabilityPoolManager__factory {
    return super.connect(signer) as StabilityPoolManager__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StabilityPoolManagerInterface {
    return new utils.Interface(_abi) as StabilityPoolManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): StabilityPoolManager {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as StabilityPoolManager;
  }
}
